import { AmbientGlow, GlassCard, ScrollReveal } from '@/components/design-system';
import { HandCoins, Link2, Recycle } from 'lucide-react';

const steps = [
  { icon: Recycle, label: 'Recover', detail: 'List your plastic' },
  { icon: Link2, label: 'Connect', detail: 'Agents & companies match' },
  { icon: HandCoins, label: 'Earn Impact', detail: 'Get paid on-chain' },
];

export function HowItWorks() {
  return (
    <section id='how-it-works' className='relative overflow-hidden py-24 md:py-32'>
      <AmbientGlow color='primary' size={420} position='top-0 left-0 -translate-x-1/3 -translate-y-1/2' />
      <AmbientGlow color='accent' size={420} position='bottom-0 right-0 translate-x-1/3 translate-y-1/2' />

      <div className='container relative'>
        <ScrollReveal className='mx-auto max-w-lg text-center'>
          <span className='text-overline'>The Loop</span>
          <h2 className='font-heading mt-2 text-headline text-foreground'>How It Works</h2>
        </ScrollReveal>

        <div className='mt-16 grid gap-6 md:grid-cols-3 md:gap-4'>
          {steps.map((step, i) => {
            const Icon = step.icon;
            return (
              <ScrollReveal key={step.label} delay={i * 0.12}>
                <div className='relative flex flex-col items-center md:flex-row md:items-start'>
                  {/* connector line to next step (desktop only) */}
                  {i < steps.length - 1 && (
                    <div className='absolute left-1/2 top-8 hidden h-px w-full -translate-x-1/2 bg-gradient-to-r from-primary/40 via-accent/40 to-transparent md:block' />
                  )}
                  <GlassCard padding='lg' className='relative z-10 w-full text-center md:text-left'>
                    <div className='mx-auto flex h-14 w-14 items-center justify-center rounded-2xl bg-gradient-to-br from-primary to-accent md:mx-0'>
                      <Icon className='h-6 w-6 text-background' strokeWidth={2} />
                    </div>
                    <div className='mt-5 flex items-baseline justify-center gap-2 md:justify-start'>
                      <span className='font-heading text-sm text-muted-foreground'>0{i + 1}</span>
                      <h3 className='font-heading text-xl font-bold text-foreground'>{step.label}</h3>
                    </div>
                    <p className='mt-1 text-sm text-muted-foreground'>{step.detail}</p>
                  </GlassCard>
                </div>
              </ScrollReveal>
            );
          })}
        </div>
      </div>
    </section>
  );
}

export default HowItWorks;
